export default __webpack_public_path__ + "static/media/flight.7b628047.png";